import type { RouteLocationNormalized } from 'vue-router'

import type { RouteAuthMeta } from '../types'

import { findRouteOrParentMatchingPredicate } from './findRouteOrParentMatchingPredicate'

/**
 * Returns the `meta.auth` of the closest route (or parent) that defines it.
 *
 * Route auth resolution is "closest wins": a child route with `meta.auth`
 * overrides a parent's. Returns `undefined` when no route in the hierarchy
 * defines `meta.auth` (i.e. a public route with no auth constraint).
 *
 * Used by the `auth` middleware, `isRouteRestricted` and `getUserLoadingStrategy`
 * so they all agree on which route owns auth/user-loading.
 */
export function getRouteAuth(
  route: RouteLocationNormalized,
): RouteAuthMeta | undefined {
  const matched = findRouteOrParentMatchingPredicate(route, (routeDefinition) =>
    Boolean(routeDefinition.meta?.auth),
  )

  return matched?.meta?.auth as RouteAuthMeta | undefined
}
